import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { IMeetingDetails } from "../../../api/IMeeting";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface MeetingDetailsProps {
  meetingDetails: IMeetingDetails;
}

const DataProtectionAlert = () => (
  <Alert variant={"secondary"} dismissible={false}>
    <div className="alert-icon">
      <FontAwesomeIcon icon={faBell} fixedWidth />
    </div>
    <div className="alert-message">
      Certain information has been withheld from this complaint record due to
      GDPR
    </div>
  </Alert>
);

const MeetingDetails = ({ meetingDetails }: MeetingDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField label={"Title"} value={meetingDetails.subject} />
          <EpaField
            label={"Organisation"}
            value={meetingDetails.organisationname}
          />
          <EpaField label={"Regarding"} value={meetingDetails.regarding} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField label={"Meeting Date"} value={meetingDetails.meetingdate} />
          <EpaField label={"Meeting Time"} value={meetingDetails.meetingtime} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12" style={{ marginTop: "20px" }}>
          <EpaFieldHtml
            label={"Location"}
            value={meetingDetails.location}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Attendees - EPA"}
            value={meetingDetails.attendeesepa}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Attendees - Licensee"}
            value={meetingDetails.attendeesnoepa}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12" style={{ marginTop: "20px" }}>
          <EpaFieldHtml
            label={"Issues and Action Items - raised by EPA"}
            value={meetingDetails.actionitems}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Meeting Details"} content={bodyElements} />;
};

export default MeetingDetails;
